"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activityStatuses = void 0;
var activityStatuses;
(function (activityStatuses) {
    activityStatuses["PENDING"] = "pending";
    activityStatuses["SENT"] = "sent";
    activityStatuses["OPENED"] = "opened";
    activityStatuses["CANCELED"] = "canceled";
    activityStatuses["REJECTED"] = "rejected";
    activityStatuses["DELAYED"] = "delayed";
    activityStatuses["ARRIVED"] = "arrived";
    activityStatuses["ACCEPTED"] = "accepted";
    activityStatuses["ANSWERED"] = "answered";
    activityStatuses["NOT_ANSWERED"] = "notAnswered";
    activityStatuses["NOT_ANSWERED_VOICEMAIL_LEFT"] = "notAnsweredVoicemailLeft";
    activityStatuses["UNREACHABLE"] = "unreachable";
    activityStatuses["COMPLETED"] = "completed";
    activityStatuses["ERROR"] = "error";
    activityStatuses["SCHEDULED"] = "scheduled";
    activityStatuses["PATIENT_VERIFIED"] = "patientVerified";
    activityStatuses["PENDING_PATIENT_VERIFICATION"] = "pendingPatientVerification";
    activityStatuses["RESOLVED"] = "resolved";
    activityStatuses["DELIVERED"] = "delivered";
    activityStatuses["WRONG_ADDRESS"] = "wrongAddress";
    activityStatuses["REFUSED"] = "refused";
    activityStatuses["SUCCESS"] = "success";
    activityStatuses["CLICKED"] = "clicked";
    activityStatuses["UNSUBSCRIBED"] = "unsubscribed";
    activityStatuses["NO_PCP"] = "noPcp";
    activityStatuses["OPTED_OUT_FROM_PCP"] = "optedOutFromPcp";
})(activityStatuses || (exports.activityStatuses = activityStatuses = {}));
